import { RepeatIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  HStack,
  IconButton,
  Input,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Text,
  Tooltip,
  useBreakpointValue,
  VStack,
} from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import CommonModal from "components/common/CommonModal/CommonModal";
import CustomDateRangeMobile from "components/common/CustomDateRangeMobile/CustomDateRangeMobile";
import CustomDateRangePicker from "components/common/CustomDateRangePicker/CustomDateRangePicker";
import { Paginationlimit } from "components/common/functions/variable";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { HiOutlineFilter, HiOutlineRefresh } from "react-icons/hi";
import { appRequest } from "routes";
import { SELLER_CLIENT_URL } from "utils/env";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import useFindBuyerName from "../../constants/function";
import CommonIssueTable from "./CommonIssueTable/CommonIssueTable";
import IssueDetails from "./IssueDetails";
import IssueStatus from "./IssueStatus/IssueStatus";
import RespondToIssue from "./IssueStatus/RespondToIssue";
import CustomInput from "components/common/customInput/CustomInput";
import { AnyARecord } from "dns";
import { useHasPermission } from "../../common/PermissionsFunction/permissiosnFunction";
import ChatBox from "../../common/HelpDesk/ChatBox";
import IssueSellerStatus from "./IssueSellerStatus";
import { formatDateYYYYMMDD } from "App/DMRC/FortamDate";

const IssueTable: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [data, setData] = useState<any[]>([]);
  const [issueData, setIssueData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterStatus, setFilterStatus] = useState<any>("");
  const [bapIdFilter, setBapIdFilter] = useState<any>("");
  const [selectedIds, setSelectedIds] = useState<any>({
    issueId: "",
    transactionId: "",
  });
  const [callApi, setCallapi] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<number>(0);
  const { bapIds } = useContext(AppContext);
  const findProviderNameByBapId = useFindBuyerName();
  const [activeTableTab, setActiveTableTab] = useState<number>(0);
  const [currentIssueStatus, setCurrentIssueStatus] = useState<any>("");
  const drawerWidth = useBreakpointValue({
    base: "100vw",
    md: "80vw",
    lg: "55vw",
  });
  const [issueID, setIssueID] = useState<string>("");
  const [debouncedIssueID, setDebouncedIssueID] = useState<string>("");
  const [raiseToSeller, setRaiseToSeller] = useState<any>("");

  const initialDateRange = {
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
    endDate: new Date(),
    key: "selection",
  };
  const [dateRange, setDateRange] = useState<any>(initialDateRange);
  const { startDate, endDate } = dateRange;

  const [messages, setMessages] = useState<any>([]);
  const [inputValue, setInputValue] = useState("");
  const [cities, setCities] = useState<any>([]);
  const [cityFilter, setCityFilter] = useState<any>("");
  const [cityCode, setCityCode] = useState<any>("");
  const [cityName, setCityName] = useState<any>("");
  const [providers, setProviders] = useState<any>([]);
  const lastMessageRef = useRef<HTMLDivElement | null>(null);
  const [callIssueApi, setCallIssueApi] = useState<boolean>(false);

  const { toastNotify } = useContext(AppContext);


  const formattedStartDate = formatDateYYYYMMDD(startDate); // Format start date
  const formattedEndDate = formatDateYYYYMMDD(endDate); // Format end date

  const getCities = async () => {
    try {
      setLoading(true);
      const response: any = await appRequest("metro", "allCities", {});

      if (response.status === "success") {
        setCities(response?.cities || []);
        // console.log("get cities response", cities);
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getIssues = useCallback(
    async (currentP?: number) => {
      try {
        setLoading(true);
        const limit = Paginationlimit;
        let page = currentP ? currentP : currentPage;
        let status = filterStatus ? filterStatus : "";
        let providerName = bapIdFilter ? bapIdFilter : "";
        let myBapId = activeTableTab;
        // let issueId = issueID ? issueID : ""
        let issueId = debouncedIssueID === undefined ? "" : debouncedIssueID;
        const id = cityFilter;
        // let myBapId = "ondc-preprod.sequelstring.com/seller/dmrc";
        const request: any = {
          limit,
          page,
          status,
          providerName,
          myBapId,
          id,
          cityCode
        };
        if (issueId.length === 0) {
          request.startDate = formattedStartDate;
          request.endDate = formattedEndDate;
        }
        if (issueId.length > 0) {
          request.issueId = issueId;
        }

        // console.log("issue request ", request);
        const response: any = await appRequest(
          "issues",
          "getAllIssuesBuyer",
          request
        );

        if (response?.status === "success") {
          setTotalPages(response?.totalPages || 0);
          setData(response?.allIssues || []);
          console.log("issue table data", response?.allIssues)
        }
      } catch (err: any) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    },
    [
      currentPage,
      filterStatus,
      bapIdFilter,
      endDate,
      activeTableTab,
      debouncedIssueID,
      callIssueApi,
      cityFilter
    ]
  );
  // for provider filter
  const getProviders = async () => {
    try {
      // console.log("city filter in getprovider", cityFilter);
      const id = cityFilter;
      const response: any = await appRequest("metro", "allProvidersForFilter", {
        id,
        cityCode
      });

      if (response.status === "success") {
        setProviders(response.allProviders || []);
        // console.log("get providers response", providers);
      }
    } catch (error: any) {
      console.error("Error fetching providers:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchChats = useCallback(
    async (data: string) => {
      try {
        let issueId = data;
        // console.log("issueId in fetchChats", issueId)
        const response: any = await appRequest("issues", "getChat", {
          issueId,
        });
        if (response.status === "success") {
          setMessages(response?.chat || []);
        }
      } catch (error: any) {
        console.log("error", error.message);
      }
    },
    [appRequest]
  );

  const handleSubmitMessage = async () => {
    try {
      if (!inputValue.trim()) {
        return toastNotify({
          title: "Validation Error",
          type: "error",
          message: "Message cannot be empty",
        });
      }

      const response: any = await appRequest("issues", "sendMessage", {
        issueId: issueData?._id, // Ensure you pass the issueId
        message: inputValue.trim(),
      });

      if (response.status === "success") {
        // Refresh the chat messages after successful submission
        fetchChats(issueData?._id);
        setInputValue(""); // Clear input field
      } else {
        toastNotify({
          title: "Error",
          type: "error",
          message: response.message || "Failed to send message",
        });
      }
    } catch (error: any) {
      console.error("Error in handleSubmitMessage:", error.message);
      toastNotify({
        title: "Error",
        type: "error",
        message: "An unexpected error occurred",
      });
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmitMessage();
    }
  };

  // console.log('activeTableTab',activeTableTab)

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  const handleIssueDetails = (data: any) => {
    setIssueData(data);
    setCurrentIssueStatus(data?.status);
    fetchChats(issueData._id);
    setIsOpen(true);
    setRaiseToSeller(data?.raisedToSeller);
  };

  const providerNames = providers.map((provider: any) => ({
    value: provider?.providerName,
    label: provider?.providerName,
  }));

  // Debounce effect for issueID
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedIssueID(issueID);
    }, 3000);

    return () => {
      clearTimeout(handler);
    };
  }, [issueID]);

  useEffect(() => {
    getIssues();
  }, [
    currentPage,
    filterStatus,
    bapIdFilter,
    endDate,
    activeTableTab,
    debouncedIssueID,
    callIssueApi,
    cityFilter,
    cityCode
  ]);

  const handleFilterChange = (e: any) => {
    if (e && e.value) {
      setFilterStatus(e.value);
    } else {
      setFilterStatus(null);
    }
  };

  const handleProviderFilterChange = (e: any) => {
    if (e && e.value) {
      setBapIdFilter(e.value);
    } else {
      setBapIdFilter(null);
    }
  };

  const handleStartDateChange = (startDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      startDate: new Date(startDate),
    }));
  };

  const handleEndDateChange = (endDate: Date) => {
    setDateRange((prevDateRange: any) => ({
      ...prevDateRange,
      endDate: new Date(endDate),
    }));
  };

  const handleIssueIdChange = (e: any) => {
    setIssueID(e.target.value.trim());
  };

  const handleDateChange = (item: any) => {
    const newStartDate = item.selection.startDate.toISOString();
    const newEndDate = item.selection.endDate.toISOString();
    handleStartDateChange(newStartDate);
    handleEndDateChange(newEndDate);
  };

  const bapNames = bapIds.map((value: any) => ({
    value: value?.bap_id,
    label: findProviderNameByBapId(value?.bap_id),
  }));

  const handleStatusOptions = [
    { value: "OPEN", label: "Open" },
    { value: "CLOSED", label: "Closed" },
    { value: "PROCESSING", label: "Processing" },
    { value: "ESCALATED", label: "Escalated" },
  ];

  const handleTableTabChange = (index: number) => {
    setActiveTableTab(index);
  };

  const handleCloseIssue = async () => {
    try {
      setLoading(true);
      await new Promise((res: any) => setTimeout(res, 1000));
      const values = {
        context: {
          transaction_id: selectedIds?.transactionId,
          domain: "ONDC:TRV11",
        },
        message: {
          issue: {
            id: issueData?.issue_id,
            status: "CLOSE",
            customer: {
              name: issueData?.user?.username,
              email: issueData?.user?.username || "",
              phone: issueData?.user?.moNumber,
            },
            category: issueData?.category,
            // sub_category: issueData?.sub_category,
            issue_details: {
              short_desc: issueData?.short_desc,
              long_desc: issueData?.long_desc,
            },
          },
        },
      };
      // const response = await createIGMFlow(
      //   "CLOSE",
      //   values,
      //   // "http://localhost:8000/client/issue"
      //   `${SELLER_CLIENT_URL}/dmrc/igm/client/issue`
      // );

      const response: any = await appRequest("seller", "issueActions", {
        values: values,
        uri: `${SELLER_CLIENT_URL}/dmrc/igm/client/issue`,
      });
      // const uri = `${SELLER_CLIENT_URL}/dmrc/igm/client/issue`;
      // const response: any = await appRequest("seller", "issueActions", {
      //   values,
      //   uri,
      // });
      if (response?.data?.message?.ack?.status === "ACK") {
        setCallapi(!callApi);
        toastNotify({
          title: "Success",
          message: "Issue Closed Successfully",
          type: "success",
        });
      } else {
        toastNotify({
          title: "Failed",
          message: "Something went wrong",
          type: "error",
        });
      }
    } catch (error) {
      console.log("error in igm close", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedCity = JSON.parse(
      localStorage.getItem("selectedCity") || "null"
    ); // Parse directly and handle null
    if (storedCity) {
      setCityFilter(storedCity.id);
      setCityCode(storedCity.cityCode)
      setCityName(storedCity.name); // Set city Name
      // console.log("Stored city data:", storedCity); // Optional: Debugging log
    } else {
      setCityFilter(null);
      setCityName(null); // Or set a default value
    }
  }, []);

  const cityNames = cities.map((city: any) => ({
    value: city?._id,
    label: city?.name,
    cityCode: city?.cityCode,
  }));

  const handleCityFilterChange = (e: any) => {
    if (e && e.value) {
      const selectedCity = {
        id: e.value, // city ID
        cityCode: e.cityCode, // city code
        name: e.label, //  city name
      };
      setCityFilter(selectedCity.id);
      setCityCode(selectedCity.cityCode)
      setCityName(selectedCity.name);
      localStorage.setItem("selectedCity", JSON.stringify(selectedCity));
    } else {
      setCityFilter(null); // or any default value you'd like to set
      localStorage.removeItem("selectedCity");
    }
  };

  // const getIssueStatus = async () => {
  //   try {
  //     const values = {
  //       context: {
  //         transaction_id: selectedIds?.transactionId,
  //         domain: "ONDC:TRV11",
  //       },
  //       message: {
  //         issue: {
  //           service: {
  //             code: "ISSUE_STATUS",
  //           },
  //           id: selectedIds?.issueId,
  //         },
  //       },
  //     };

  //     const uri = `${SELLER_CLIENT_URL}/dmrc/igm/client/issue_status`;
  //     const issueStatusResponse: any = await appRequest(
  //       "seller",
  //       "issueActions",
  //       {
  //         values,
  //         uri,
  //       }
  //     );

  //     if (issueStatusResponse?.data?.message?.ack?.status === "ACK") {
  //       return issueStatusResponse;
  //     } else {
  //       console.error("Unexpected response format:", issueStatusResponse.data);
  //       throw new Error("Unexpected response from API.");
  //     }
  //   } catch (error: any) {
  //     const errorMessage =
  //       error?.response?.data?.message ||
  //       error?.response?.data ||
  //       error.message;
  //     toastNotify({
  //       title: "Error",
  //       message: `Failed to fetch issue status: ${errorMessage}`,
  //       type: "error",
  //     });
  //     throw new Error(errorMessage);
  //   }
  // };

  useEffect(() => {
    getCities();
  }, []);

  useEffect(() => {
    getProviders();
  }, [cityFilter, cityCode]);

  const canUpdateIssue = useHasPermission("canUpdateIssue");
  return (
    <Box
      p={5}
      rounded={"lg"}
      bg={"white"}
      shadow={"rgb(0 0 0 / 20%) 0px 0px 11px"}
    >
      <Tabs
        colorScheme="teal"
        onChange={handleTableTabChange}
        size={{ base: "sm", md: "md" }}
      >
        <Flex
          justify={"space-between"}
          direction={{ base: "column", lg: "row" }}
        >
          <TabList
            gap={{ base: 1, md: 3 }}
            // w={"100%"}
            mb={{ base: 2, md: "unset" }}
          >
            <Tab fontWeight={500}>Buyer Issues</Tab>
            {/* {useHasPermission("canRaiseIssue") && (
              <Tab fontWeight={500}>My Issues</Tab>
            )} */}
          </TabList>

          <Flex
            gap={2}
            direction={{ base: "column", lg: "row" }}
          >
            <Flex align="center" gap={2} mb={{ base: 2, lg: 0 }}>
              {cityFilter ? (
                <Text fontWeight="bold" fontSize="md" color="teal.600">
                  City:{cityName}
                </Text>
              ) : (
                <Text fontWeight="bold" fontSize="md" color="gray.500">
                  No City Selected
                </Text>
              )}
            </Flex>
            {/* <Flex justify={"end"} gap={2}> */}
            <Box display={{ base: "none", lg: "block" }}>
              <CustomDateRangePicker
                dateFrom={dateRange.startDate && new Date(dateRange.startDate)}
                dateTo={dateRange.endDate && new Date(dateRange.endDate)}
                onStartDateChange={handleStartDateChange}
                onEndDateChange={handleEndDateChange}
                months={2}
              />
            </Box>
            <Box display={{ base: "block", lg: "none" }}>
              <CustomDateRangeMobile
                range={[dateRange]}
                onChange={handleDateChange}
              />
            </Box>
            {/* </Flex> */}
            <Grid templateColumns="1fr 1fr" gap={2} alignItems={'center'}>
              <Tooltip label="Refresh" hasArrow>
                <IconButton
                  aria-label="Refresh"
                  icon={<HiOutlineRefresh />}
                  colorScheme="teal"
                  variant={"outline"}
                  // borderWidth={2}
                  onClick={() => {
                    setDateRange(initialDateRange);
                    setBapIdFilter("");
                    setFilterStatus("");
                    setDebouncedIssueID("");
                  }}
                  size={{ base: "sm", md: "md" }}
                />
              </Tooltip>
              <Popover>
                <PopoverTrigger>
                  <IconButton
                    aria-label="Filter"
                    colorScheme="teal"
                    icon={<HiOutlineFilter />}
                    size={{ base: "sm", md: "md" }}
                  />
                </PopoverTrigger>
                <Portal>
                  <PopoverContent shadow={"lg"} borderWidth={2}>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverBody p={5}>
                      <VStack spacing={6} mt={2}>
                        <CustomSelect
                          options={cityNames}
                          label={"Filter By City"}
                          onChange={handleCityFilterChange}
                        />
                        {/* <CustomSelect
                          options={providerNames}
                          label={"Providers"}
                          onChange={handleProviderFilterChange}
                        /> */}
                        <CustomSelect
                          options={handleStatusOptions}
                          label={"Filter By Status"}
                          onChange={handleFilterChange}
                        />
                        <CustomInput
                          name={"Filter By Issue ID"}
                          label={"Filter By Id"}
                          onChange={handleIssueIdChange}
                        />
                      </VStack>
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>
            </Grid>
          </Flex>
        </Flex>
        <TabIndicator
          mt="-1.5px"
          height="3px"
          bg="teal.500"
          borderRadius="2px"
          display={{ base: "none", lg: "block" }}
        />
        <TabPanels>
          {cityFilter ? (
            <TabPanel px={{ base: 0, md: 4 }}>
              <CommonIssueTable
                loading={loading}
                setSelectedIds={setSelectedIds}
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
                handleIssueDetails={handleIssueDetails}
                data={data}
              />
            </TabPanel>
          ) : (
            <Box p={4}>
              <Text fontSize="lg" color="red.700" textAlign="center">
                No city is selected. Please select a city.
              </Text>
            </Box>
          )}
          {/* {useHasPermission("canRaiseIssue") && (
            <TabPanel px={{ base: 0, md: 4 }}>
              <CommonIssueTable
                loading={loading}
                setSelectedIds={setSelectedIds}
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
                handleIssueDetails={handleIssueDetails}
                data={data}
              />
            </TabPanel>
          )} */}
        </TabPanels>
      </Tabs>
      <CommonModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        animate={true}
        width={drawerWidth}
        header={
          <Box mb={2}>
            <HStack
              spacing={{ base: 0, md: 2 }}
              align={"center"}
              flexDirection={{ base: "column", md: "row" }}
            >
              <Text
                fontSize={{ base: "md", md: "xl" }}
                fontWeight="500"
                color="teal.600"
                mb={2}
              >
                <Text as={"span"} fontWeight={700}>
                  {" "}
                  Issue ID:
                </Text>{" "}
                {issueData.issue_id}
              </Text>
              <Tag colorScheme={issueData?.status === "OPEN" ? "green" : issueData?.status === "RESOLVED" ? "green" : "red"}>
                {issueData?.status}
              </Tag>
            </HStack>
          </Box>
        }
        body={
          <Box>
            <Tabs
              colorScheme="teal"
              variant={"soft-rounded"}
              // index={activeTab}
              onChange={(index) => setActiveTab(index)}
              size={{ base: "sm", md: "md" }}
            >
              <Flex justify={"space-between"}>
                <TabList>
                  <Tab>Details</Tab>
                  <Tab>Status</Tab>
                  <Tab onClick={() => fetchChats(issueData._id)}>Chat</Tab>
                  {raiseToSeller === true ? <Tab>Seller Status</Tab> : null}
                </TabList>
                {activeTableTab === 1 && (
                  <Tooltip label="Fetch status" placement="left" hasArrow>
                    <IconButton
                      onClick={() => {
                        setCallapi(!callApi);
                        // getIssueStatus();
                      }}
                      variant={"outline"}
                      colorScheme="teal"
                      aria-label="Refresh"
                      icon={<RepeatIcon />}
                    />
                  </Tooltip>
                )}
              </Flex>

              <TabPanels>
                <TabPanel px={{ base: 0, md: 4 }}>
                  <IssueDetails data={issueData} />
                </TabPanel>
                <TabPanel px={{ base: 0, md: 4 }}>
                  <IssueStatus
                    selectedIds={selectedIds}
                    callApi={callApi}
                    data={issueData}
                  />
                </TabPanel>
                <TabPanel px={{ base: 0, md: 4 }}>
                  {/* chatbox */}
                  <ChatBox
                    {...{
                      setIssueData,
                      messages,
                      issueData,
                      fetchChats,
                      handleSubmitMessage,
                      inputValue,
                      handleChange,
                      handleKeyDown,
                      lastMessageRef,
                      // fetchQueries,
                    }}
                  />
                </TabPanel>
                { }
                <TabPanel px={{ base: 0, md: 4 }}>
                  {raiseToSeller === true ? (
                    <IssueSellerStatus data={issueData} />
                  ) : null}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        }
        footer={
          <>
            {activeTab === 1 &&
              activeTableTab === 0 &&
              canUpdateIssue &&
              ["OPEN", "PROCESSING", "ESCALATED"].includes(
                currentIssueStatus
              ) && (
                <RespondToIssue
                  selectedIds={selectedIds}
                  setCallapi={setCallapi}
                  data={issueData}
                  callIssueApi={callIssueApi}
                  setCallIssueApi={setCallIssueApi}
                />
              )}

            {/* {useHasPermission("canRaiseIssue") &&
              activeTableTab === 1 &&
              currentIssueStatus === "OPEN" && (
                <Button
                  colorScheme="red"
                  isLoading={loading}
                  onClick={handleCloseIssue}
                >
                  Close Issue
                </Button>
              )} */}
          </>
        }
      />
    </Box>
  );
};

export default IssueTable;
